import { render, staticRenderFns } from "./ReceiptFromProductionMaterialInput.vue?vue&type=template&id=7047657d&scoped=true&"
import script from "./ReceiptFromProductionMaterialInput.vue?vue&type=script&lang=js&"
export * from "./ReceiptFromProductionMaterialInput.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptFromProductionMaterialInput.vue?vue&type=style&index=0&id=7047657d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7047657d",
  null
  
)

export default component.exports